import React from 'react';
import { Link } from 'react-router-dom';

import ProcessManager from '../../../Common/Managers/ProcessManager';

import BotonEliminar from './BotonEliminar.jsx';
import BotonBloqueo from './BotonBloqueo.jsx';
import BotonDesbloqueo from './BotonDesbloqueo';
import BotonRecuperar from './BotonRecuperar';

const HeaderButtons = (props) => {
    let Bloqueados = props.usuariosFiltrados.filter(x => x.Seleccionado == true && x.Bloqueado == true).length;
    let Desbloqueados = props.usuariosFiltrados.filter(x => x.Seleccionado == true && x.Bloqueado == false && x.Activo == true).length;

    let Eliminados = props.usuariosFiltrados.filter(x => x.Seleccionado == true && x.Activo == false && x.FechaEliminado).length;
    let Recuperados = props.usuariosFiltrados.filter(x => x.Seleccionado == true && x.Activo == true).length;

    return (
        <div className="row">
            <div className="col-md-6">
                {
                    props.functions.Alta &&
                    <Link to={ProcessManager.GetNextStep("ListaDeUsuarios", "ROUTE_TO_ALTA_MOD_USUARIO") + '/' + 0}>
                        <button className="btn btn-cta" type="button">Nuevo</button>
                    </Link>
                }
            </div>
            <div className="col-md-3">
                {
                    (Desbloqueados > Bloqueados) ?
                        <BotonBloqueo
                            usuariosFiltrados={props.usuariosFiltrados}
                            setMotivoBloqueo={props.setMotivoBloqueo}
                            setUserState={props.setUserState}
                        /> : <BotonDesbloqueo
                            usuariosFiltrados={props.usuariosFiltrados}
                            setUserState={props.setUserState}

                        />
                }
            </div>
            <div className="col-md-3">
                {
                    (Recuperados < Eliminados) ?
                        <BotonRecuperar
                            usuariosFiltrados={props.usuariosFiltrados}
                            setUserState={props.setUserState}
                        /> :
                        <BotonEliminar
                            usuariosFiltrados={props.usuariosFiltrados}
                            setUserState={props.setUserState}
                        />
                }
            </div>
        </div>
    );
}

export default HeaderButtons;